export default __webpack_public_path__ + "images/0xb79dd08ea68a908a97220c76d19a6aa9cbde4376.png";